<ion-header>
  <ion-toolbar>
    <ion-title>{{
      isEditMode ? "Edit Collection" : "Create New Collection"
    }}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="onCancel()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="modal-content">
  <form [formGroup]="collectionForm" (ngSubmit)="onSubmit()">
    <!-- Icon Selection Section -->
    <div class="form-section">
      <div class="input-group">
        <div class="input-wrapper">
          <ion-label class="input-label">
            Collection Icon <span class="optional">(Optional)</span>
          </ion-label>
          <div class="icon-selection-container">
            <ion-button
              fill="clear"
              (click)="selectIcon()"
              class="icon-selection-button"
              [title]="selectedIcon ? 'Change Icon' : 'Choose Icon'"
            >
              <div class="icon-preview">
                <div *ngIf="currentIconComponent">
                  <lucide-icon
                    [img]="currentIconComponent"
                    class="selected-icon"
                  ></lucide-icon>
                </div>
                <div *ngIf="!currentIconComponent" class="icon-placeholder">
                  <ion-icon
                    name="add-outline"
                    class="placeholder-icon"
                  ></ion-icon>
                </div>
              </div>
              <span class="icon-selection-text">
                {{ selectedIcon ? "Change Icon" : "Choose Icon" }}
              </span>
            </ion-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Collection Name Section -->
    <div class="form-section">
      <div class="input-group">
        <div class="input-wrapper">
          <ion-label class="input-label">
            Collection Name <span class="required">*</span>
          </ion-label>
          <ion-input
            formControlName="name"
            placeholder="Enter collection name"
            class="form-input"
            [class.invalid]="
              collectionForm.get('name')?.invalid &&
              collectionForm.get('name')?.touched
            "
          ></ion-input>
          <div
            *ngIf="
              collectionForm.get('name')?.invalid &&
              collectionForm.get('name')?.touched
            "
            class="error-message"
          >
            Collection name is required
          </div>
        </div>
      </div>
    </div>

    <!-- Description Section -->
    <div class="form-section">
      <div class="input-group">
        <div class="input-wrapper">
          <ion-label class="input-label">
            Description <span class="optional">(Optional)</span>
          </ion-label>
          <ion-textarea
            formControlName="description"
            placeholder="Enter collection description"
            rows="3"
            auto-grow="true"
            class="form-textarea"
          ></ion-textarea>
        </div>
      </div>
    </div>
  </form>

  <!-- Portal Inclusion Section (only show when creating new collection and live portals exist) -->
  <div class="form-section" *ngIf="!isEditMode && hasLivePortals">
    <div class="input-group">
      <div class="input-wrapper">
        <div class="input-label-container">
          <ion-label class="input-label">Include in live portals</ion-label>
          <ion-icon
            name="help-circle-outline"
            class="help-icon"
            ngxTippy
            [tippyProps]="{
              content:
                'Select which live portals this collection should be visible in. Only portals matching your project type are shown. Collections are visible in portals by default unless explicitly excluded.',
              placement: 'top',
              arrow: false,
              theme: 'light'
            }"
          ></ion-icon>
        </div>

        <!-- Show checkbox for each portal -->
        <div class="portal-list">
          <ion-item
            class="portal-inclusion-item"
            *ngFor="let portal of livePortals"
            lines="none"
            (click)="$event.stopPropagation()"
          >
            <ion-checkbox
              [(ngModel)]="selectedPortals[portal.id]"
              slot="start"
            ></ion-checkbox>
            <ion-label class="portal-inclusion-label">
              <div class="portal-inclusion-title">
                {{ portal.isExternal ? "External" : "Internal" }} Portal
              </div>
            </ion-label>
          </ion-item>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="modal-footer">
  <ion-button
    fill="clear"
    (click)="onCancel()"
    [disabled]="isLoading"
    color="medium"
  >
    Cancel
  </ion-button>
  <ion-button
    (click)="onSubmit()"
    [disabled]="!collectionForm.valid || isLoading"
  >
    <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
    <span *ngIf="!isLoading">{{ isEditMode ? "Save" : "Create" }}</span>
  </ion-button>
</ion-footer>
